import React from 'react';
import './Services.css';

const courseGroups = [
  {
    title: '60分コース',
    detail: 'トレーニング55分 / 着替え等5分',
  },
  {
    title: '80分コース',
    detail: 'トレーニング75分 / 着替え等5分',
  },
];

const Services: React.FC = () => {
  return (
    <div className="n-page n-services">
      <header className="n-page-header">
        <div className="container">
          <span className="n-page-eyebrow">PRICING / COURSES</span>
          <h1>PRICING</h1>
          <p>コース・料金</p>
        </div>
      </header>
      <section className="n-page-body">
        <div className="n-page-content">
          <section className="n-pricing-guidance" aria-label="最新の料金について">
            <div>
              <span className="n-page-eyebrow">PRICE & CAMPAIGN</span>
              <h2>最新の料金は公式LINEでご案内</h2>
              <p>コース料金やキャンペーン、オプション費用は変更となる場合があります。<br />ご検討中の方は、公式LINEで最新情報をご確認ください。</p>
            </div>
            <a href="https://lin.ee/sPhllf4M" target="_blank" rel="noopener noreferrer" className="n-page-cta">
              公式LINEで料金を確認 <span aria-hidden="true">↗</span>
            </a>
          </section>

          <section className="n-menu-description">
            <span className="n-page-eyebrow">MENU</span>
            <h2>メニュー説明</h2>
            <p>筋力トレーニング、ヨガ、ストレッチ、ピラティスからお選びいただけます。</p>
          </section>

          <div className="n-course-groups">
            {courseGroups.map((course) => (
              <section className="n-course-group" key={course.title}>
                <header className="n-course-heading">
                  <h2>{course.title}</h2>
                  <p>{course.detail}</p>
                </header>
                <p className="n-course-line">筋力トレーニング・ヨガ・ストレッチ・ピラティスに対応</p>
              </section>
            ))}
          </div>

          <p className="n-course-note">回数プラン・有効期限・ウェア等のオプションについても、公式LINEでご案内しています。</p>
        </div>
      </section>
    </div>
  );
};

export default Services;